import { CommonSchemaIds } from './common.const.js';
import { RoleSchemaIds, RoleTags } from "./role.const.js";
export const ROLE_TLMD_SCHEMAS = {
    [RoleSchemaIds.ROLE]: {
        id: RoleSchemaIds.ROLE,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            _id: {
                ref: CommonSchemaIds.UUID,
                required: true,
                usage: [RoleTags.SYSTEM, RoleTags.DOMAIN],
            },
            name: {
                ref: CommonSchemaIds.NAME,
                required: true,
                usage: [
                    { tag: RoleTags.SYSTEM, input: { read: 1 } },
                    { tag: RoleTags.DOMAIN },
                ],
            },
            title: {
                ref: CommonSchemaIds.TITLE,
                required: true,
                usage: [
                    { tag: RoleTags.SYSTEM, input: { read: 1 } },
                    { tag: RoleTags.DOMAIN },
                ],
            },
            domain: {
                ref: CommonSchemaIds.DOMAIN,
                required: true,
                usage: [
                    { tag: RoleTags.SYSTEM, input: { read: 1 } },
                    { tag: RoleTags.DOMAIN, input: { create: -1, read: -1, update: -1 } },
                ],
            },
            active: {
                ref: CommonSchemaIds.ACTIVE,
                required: true,
                usage: [
                    { tag: RoleTags.SYSTEM, input: { read: 1 } },
                    { tag: RoleTags.DOMAIN, input: { create: -1, read: 1, update: 1 } },
                ],
            },
            deleted: {
                ref: CommonSchemaIds.DELETED,
                required: true,
                usage: [
                    { tag: RoleTags.SYSTEM, input: { read: 1 } },
                    { tag: RoleTags.DOMAIN, input: { create: -1, read: 1, update: 1 } },
                ],
            },
        },
    }
};
